import { dataHooks } from '@wix/data-hooks';

export const templateImageDataHooks = dataHooks<{
  image: { key: string };
  editButton: { key: string };
  viewButton: { key: string };
}>('template-image');
